import {
  CardContainer,
  CardTitle,
  CardDetail,
  CardList,
} from "./CategoriesStyle";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";

const fetchCategories = async () => {
  return axios.get(
    "https://ancient-caverns-61891.herokuapp.com/api/v1/categories"
  );
};

const Card = (list) => {
  const { data, error, isLoading } = useQuery("categories", fetchCategories, {
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  if (isLoading) return <h1>Loading...</h1>;

  return (
    <CardContainer>
      <div>
        <CardTitle>Categories</CardTitle>
        <CardDetail>
          {data.data.data.categories.map((category) => {
            return (
              <Link to={`#/category/${category._id}`}>
                <CardList key={category._id}>
                  <img src={category.image} alt="" width={40} height={40} />
                  <p>{category.name}</p>
                </CardList>
              </Link>
            );
          })}
        </CardDetail>
      </div>
    </CardContainer>
  );
};

export default Card;
